import {
    GeolocationBoundaries,
    multiPolygonCenter,
    polygonCenter,
} from '../../../../domains/Geolocation/Geolocation';
import {
    imageUrlForStaticCdn,
    TRANSPARENT_PIXEL_BASE64,
} from '../../../../domains/Layout/Image/URL/ImageURL';
import { WemapPinpoint } from '../types/Wemap';

const WEMAP_PINPOINT_IMAGE_SIZE = 64;

export function createWemapRegionPinpoint({
    id,
    name,
    boundaries,
}: {
    id: number;
    name: string;
    boundaries: GeolocationBoundaries;
}): WemapPinpoint {
    const [longitude, latitude] =
        boundaries.type === 'Polygon' ? polygonCenter(boundaries) : multiPolygonCenter(boundaries);

    const coordinates =
        boundaries.type === 'Polygon'
            ? boundaries.coordinates.map((coordinates) => {
                  return coordinates.map(({ longitude, latitude }) => {
                      return [longitude, latitude] as [number, number];
                  });
              })
            : boundaries.coordinates.map((coordinates) => {
                  return coordinates.map((a) => {
                      return a.map(({ longitude, latitude }) => {
                          return [longitude, latitude] as [number, number];
                      });
                  });
              });

    return {
        id,
        name,
        longitude,
        latitude,
        geo_entity_shape: {
            type: 'Feature' as const,
            properties: {
                fill: '#00543c',
                'fill-opacity': 0.1,
                stroke: '#00543c',
                'stroke-opacity': 0.2,
            },
            geometry: {
                type: boundaries.type,
                coordinates: coordinates,
            },
        },
        type: 1,
    };
}

export function createWemapPlacePinpoint({
    id,
    name,
    longitude,
    latitude,
    imageId,
}: {
    id: number;
    name: string;
    longitude: number;
    latitude: number;
    imageId?: string;
}): WemapPinpoint {
    return {
        id,
        name,
        longitude,
        latitude,
        image_url: imageId
            ? imageUrlForStaticCdn(
                  imageId,
                  WEMAP_PINPOINT_IMAGE_SIZE * 2,
                  WEMAP_PINPOINT_IMAGE_SIZE * 2,
              )
            : TRANSPARENT_PIXEL_BASE64,
        type: 1,
    };
}
